<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="450px" class="confirmProp" :close-on-click-modal="false">
		<div>
			<div class="textC">
				<i class="iconfont icontishichuang3 tanchuang-icon" style="color:#ff9595"></i>
				<!-- <img src="../../assets/img/tanchuang/icon-3.png" alt="" class="imgsize"> -->
			</div>
			<div class="texts textC">{{ tips2 }}</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="addbtn" class="addbtn btn-icon-flex">
				<i class="iconfont iconqueding btn-icon"></i>
				<span>确 定</span>
			</el-button>
			<el-button type="primary" @click="dialogVisible = false" class="deletbtn btn-icon-flex">
				<i class="iconfont iconguanbi btn-icon textColor btn-quxiao" ></i>
				<span>取 消</span>
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'ConfirmWarningProp2',
	props: {
		tips: {
			type: String,
			default: '警告提示确认框'
		}
	},
	data() {
		return {
			dialogVisible: false,
			tips2: ''
		};
	},
	methods: {
		addbtn() {
			this.$emit('sucess', 'ok');
			this.dialogVisible = false;
		},
		show(str) {
			this.tips2 = str;
			this.dialogVisible = true;
		}
	}
};
</script>

<style lang="less">
.confirmProp {
	.el-dialog .el-dialog__body {
		padding-top: 33px;
		padding-bottom: 44px;
	}

	.el-dialog .el-dialog__footer {
		padding-top: 0px;
		padding-bottom: 39px;
	}

	.texts {
		font-family: MicrosoftYaHei;
		// font-size: 18px;
		// font-weight: normal;
		// font-stretch: normal;
		// letter-spacing: 1px;
		// color: #47ba6d;
		margin-top: 12px;

		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #666666;
	}

	.addbtn {
		width: 140px;
		height: 40px;
		background-color: #0092f1;
		border-radius: 3px;
		padding: 0px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 12px 42px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content:space-around;
			justify-content: center;
		}
	}

	.deletbtn {
		width: 140px;
		height: 40px;
		background-color: #fff;
		border-radius: 3px;
		font-family: MicrosoftYaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #0092f1;
		padding: 0px;
		margin-left: 27px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 12px 42px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content:space-around;
			justify-content: center;
		}
	}

	.imgsize {
		width: 72px;
		// height: 72px;
	}
}
</style>
